// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Skeleton, Stack, Tabs, Text as MantineText } from '@mantine/core';
import { IconUser } from '@tabler/icons';
import { FC, useContext, useEffect } from 'react';
import { ConstantS } from '../../../Service/ConstantS';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { useMailOutboundConfigs } from '../../../Service/hooks/useMailOutboundConfigs';
import { MixpanelS } from '../../../Service/MixpanelS';
import { getDisplayName } from './bookitupTeamUtils';
import TeamMemberDetails from './TeamMemberDetails';
import TeamMemberRemoveAction from './TeamMemberRemoveAction';

const TeamMembers: FC = () => {
  const { bookitupTeam } = useContext(ProfileContext);
  const { ensureSharesLoaded, loading, shares, selectedApplicationUserId, selectedShare, selectShare } = bookitupTeam;
  const { loading: loadingMailAccounts, mailOutboundConfigs } = useMailOutboundConfigs();

  useEffect(() => {
    ensureSharesLoaded().catch(() => undefined);
  }, [ensureSharesLoaded]);

  if (loading && !selectedShare) {
    return (
      <Stack>
        <Skeleton height={42} />
        <Skeleton height={120} />
        <Skeleton height={240} />
      </Stack>
    );
  }

  if (!selectedShare) {
    return <MantineText color="dimmed">Keine Teammitglieder vorhanden.</MantineText>;
  }

  return (
    <Tabs
      value={selectedApplicationUserId?.toString()}
      onTabChange={(value) => {
        if (value) {
          const appUserId = Number(value);
          selectShare(appUserId);
          MixpanelS.track(ConstantS.TrackingEvents.TeamMemberTabOpened, { appUserId });
        }
      }}
      styles={(theme) => ({
        tab: {
          '&[data-active]': {
            fontWeight: 'bolder',
            color: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[3],
          },
        },
      })}
    >
      <Tabs.List sx={{ flexWrap: 'nowrap', overflowX: 'auto' }}>
        {shares.map((share) => (
          <Tabs.Tab
            key={share.applicationUserId}
            value={share.applicationUserId.toString()}
            icon={<IconUser size={14} />}
            rightSection={<TeamMemberRemoveAction share={share} />}
          >
            {getDisplayName(share)}
          </Tabs.Tab>
        ))}
      </Tabs.List>

      {shares.map((share) => (
        <Tabs.Panel key={share.applicationUserId} value={share.applicationUserId.toString()} pt="xs">
          <TeamMemberDetails
            share={share}
            mailOutboundConfigs={mailOutboundConfigs}
            loadingMailAccounts={loadingMailAccounts}
          />
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};

export default TeamMembers;
